import React from 'react';
import styled from 'styled-components';

// PARTİ 19 — BU BİLEŞEN KLAVYEYE KAPALIYDI (ürün geneli, 42 dosya / 86 kullanım).
//
// Eski gövde: `onClick`li bir `<label>` + boyalı bir `<div>`. Gerçek bir
// `<input type="checkbox">` YOKTU. Sonuçları:
//   • Tab kutuyu ATLIYORDU, Boşluk/Enter hiçbir şey yapmıyordu — klavye ya da
//     ekran okuyucu kullanan bir kişi hiçbir onay kutusunu işaretleyemiyordu.
//     Kariyer başvuru formunda onay ZORUNLU olduğu için o kişi işe
//     BAŞVURAMIYORDU (FE-36'nın yanında çıkan sert bulgu).
//   • Ekran okuyucuya hiçbir şey bildirilmiyordu: ne rol, ne işaretli durumu.
//   • `disabled` prop'u ÖLÜYDÜ: `CanteenSettingsPage` salt-okunur kullanıcı için
//     `disabled={!canWrite('CN')}` geçiyordu, bileşen bunu hiç okumuyordu —
//     kutu tıklanabilir kalıyor, arayüz yalan söylüyordu.
//
// Çözüm: GÖRÜNMEZ AMA GERÇEK bir native checkbox. Native olan her şeyi tarayıcı
// verir — sekme sırası, Boşluk, `aria-checked`, `disabled`, form katılımı,
// ekran okuyucu duyurusu. Kutu yalnız BOYAdır (`aria-hidden`), rol taşımaz;
// aksi halde aynı kontrol iki kez duyurulurdu.
//
// `opacity: 0` seçildi — `display:none`/`visibility:hidden` odağı da alır
// (Parti 10'un off-canvas menü dersi: ekran dışı öğe odağı YUTAR).
//
// SÖZLEŞME DEĞİŞMEDİ: `onChange` hâlâ BOOLEAN alır (olay nesnesi değil), yani
// 86 çağrı yerinin hiçbiri değişmek zorunda değil.

const Wrapper = styled.label`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  user-select: none;
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
`;

const Box = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid ${({ $checked, theme }) => ($checked ? theme.colors.primary.main : '#D0D5DD')};
  border-radius: 4px;
  background: ${({ $checked, theme }) => ($checked ? theme.colors.primary.main : '#fff')};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
  flex-shrink: 0;
`;

// Görünmez ama ODAKLANABİLİR. Kutunun tam üstünde durur ki fare tıklaması da
// doğrudan input'a gitsin (label yönlendirmesine ek güvence).
const NativeInput = styled.input`
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  margin: 0;
  opacity: 0;
  cursor: inherit;

  &:focus-visible + ${Box} {
    outline: 2px solid ${({ theme }) => theme.colors.primary.main};
    outline-offset: 3px;
  }
`;

const Check = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path d="M2 6L5 9L10 3" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const Label = styled.span`
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  color: ${({ theme }) => theme.colors.text.primary};
`;

// `forwardRef`: doğrulama hatasında odağı kusurlu alana götüren sayfalar
// (ör. kariyer başvuru formu) kutuya bir ref bağlamak zorunda. Ref ODAKLANABİLİR
// öğeye, yani native input'a gider — boyalı `<div>`e değil.
const CheckboxInput = React.forwardRef(function CheckboxInput(
  { label, checked, onChange, disabled = false, ...rest }, ref,
) {
  // `!!checked`: çağrı yerlerinin bir kısmı ilk render'da `undefined` geçiyor;
  // ham değerle React "kontrolsüzden kontrollüye geçiş" uyarısı verirdi.
  const isChecked = !!checked;
  return (
    <Wrapper $disabled={disabled}>
      <NativeInput
        ref={ref}
        type="checkbox"
        checked={isChecked}
        disabled={disabled}
        onChange={(e) => onChange?.(e.target.checked)}
        {...rest}
      />
      <Box $checked={isChecked} aria-hidden="true">{isChecked && <Check />}</Box>
      {label && <Label>{label}</Label>}
    </Wrapper>
  );
});

export default CheckboxInput;
